import React, { useState, useEffect, Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/20/solid";

const pageSizeOptions = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 75, label: "75" },
  { value: 100, label: "100" },
];

export default function V2ListBoxPageSize({ value, onChange, showLabel = true, compactHeight = false, }) {
  const [selected, setSelected] = useState(
    pageSizeOptions.find((o) => o.value === value) || pageSizeOptions[0]
  );

  useEffect(() => {
    setSelected(pageSizeOptions.find((o) => o.value === value) || pageSizeOptions[0]);
  }, [value]);

  const handleChange = (opt) => {
    setSelected(opt);
    onChange?.(opt.value);
  };

  return (
    <div className="flex items-center gap-2">
      {showLabel && (
        <span className="text-[11px] uppercase tracking-wide text-gray-600">
          Risultati per pagina
        </span>
      )}

      <div className="relative">
        <Listbox value={selected} onChange={handleChange}>
          <div className="relative">
            {/* Trigger */}
            <Listbox.Button
              className={`
                inline-flex items-center gap-2
                rounded-xl border border-gray-200 bg-white px-3
                ${compactHeight ? "h-10 py-0" : "py-2"}
                text-sm font-medium text-gray-800 shadow-sm
                hover:border-indigo-300 hover:bg-indigo-50/40
                focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/50
                transition min-w-[4.5rem]
              `}
            >
              <span className="truncate">{selected?.label ?? "Seleziona"}</span>
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
            </Listbox.Button>

            {/* Menu */}
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-75"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Listbox.Options
                className="
                  absolute right-0 z-50 mt-2 w-28 origin-top-right
                  rounded-xl bg-white p-1 text-sm shadow-xl ring-1 ring-black/5
                  focus:outline-none
                "
              >
                {pageSizeOptions.map((opt) => (
                  <Listbox.Option
                    key={opt.value}
                    value={opt}
                    className={({ active }) =>
                      `
                      group relative flex cursor-pointer select-none items-center justify-between
                      rounded-lg px-3 py-2
                      ${active ? "bg-indigo-50 text-indigo-900" : "text-gray-800"}
                    `
                    }
                  >
                    {({ selected }) => (
                      <>
                        <span className="truncate">{opt.label}</span>
                        {selected && (
                          <CheckIcon className="h-5 w-5 text-indigo-600" />
                        )}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>
    </div>
  );
}